import data from "../../shared/sharedData";

export default {
  name: "Crop or Commodity Profile",
  sections: [
    {
      name: "Type of Crop or Commodity",
      fields: [
        {
          machine_name: "new_profile_crop_crop_id",
          widget: "text",
          label: "Crop ID",
          maxLength: 4,
          validate: [],
          tooltip: "Enter the Crop ID.",
        },
        {
          machine_name: "new_profile_crop_crop_work_state",
          label: "Work State",
          validate: ["required"],
          widget: "select",
          selection: data.abbreviatedState,
          maxLength: 2,
          tooltip: `Enter the two-letter abbreviation for the State or territory in which the crop or agricultural activity will be performed.  For example, if the crop or agricultural activity will be performed in the State of California, enter “CA” in this field.`,
        },
        {
          machine_name: "new_profile_crop_crop_agricultural_activity",
          widget: "text_area",
          label: "Crop or Agricultural Activity",
          maxLength: 100,
          placeholder: "",
          width: 5,
          rows: 5,
          inputLimit: 100,
          validate: [
            "required",
            {
              minLength: 5,
            },
          ],
          tooltip: "Enter the crop or agricultural activity.",
        },
        {
          machine_name: "new_profile_crop_wage_offer",
          widget: "wage",
          validate: ["required"],
          maxLength: 4, // accounts for the "$" and decimals
          label: "Wage Offer",
          tooltip: "Enter the wage offer.",
        },
        {
          isGroup: {
            label: "Per",
            machine_name: "new_profile_crop_per",
            validate: ["required"],
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Hour",
                value: "Hour",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Month",
                value: "Month",
                validate: ["required"],
              },
            ],
            tooltip: "Enter the wage per frequency.",
          },
        },
        {
          machine_name: "new_profile_crop_piece_rate_offer",
          label: "Piece Rate Offer",
          widget: "wage",
          validate: ["required"],
          tooltip: `Enter any piece rate that will be offered, advertised, and paid to workers performing the job duties or services in the “Crop or Agricultural Activity” under Column 2.`,
          maxLength: 4, // accounts for the "$" and decimals
        },
        {
          machine_name: "new_profile_crop_piece_rate_units",
          widget: "text_area",
          maxLenght: 500,
          label:
            "Piece Rate Units / Estimated Hourly Rate / Special Pay Information",
          placeholder: "",
          validate: [
            {
              minLength: 5,
            },
          ],
          width: 8,
          rows: 10,
          inputLimit: 500,
          tooltip: "Enter the piece rate units or special pay information.",
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_crop_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          maxLength: 50,
          validate: ["required"],
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
